export enum NHCustomQuestionKeys {
  APPLICATION_DOCUMENTS = 'documents',
  APPLICATION_RECEIVED_ASSISTANCE = 'submission.assistance.receivedAssistance',
  FINANCIAL_HARDSHIP_EXPERIENCE = 'financialHardship.experience',
  FINANCIAL_HARDSHIP_INCOME = 'financialHardship.income',
  FINANCIAL_HARDSHIP_STATEMENT = 'financialHardship.statement.qualifiedBenefits',
  HOUSEHOLD_INCOME = 'householdIncome',
  HOUSEHOLD_MEMBERS_PUBLIC_BENEFITS = 'publicBenefits',
  HOUSING_INSTABILITY_RECEIVED_DOCUMENTS = 'housingInstability.receivedDocuments',
  HOUSING_INSTABILITY_STATEMENT = 'housingInstability.statement.riskOfHomelessness',
  HOUSING_INSTABILITY_UNSAFE_CONDITIONS = 'housingInstability.unsafeConditions',
  LANDLORD = 'address.landlord',
  REQUESTS_OTHER_EXPENSES = 'requests.otherExpenses',
  REQUESTS_RENTAL_ASSISTANCE = 'requests.rentalAssistance',
  REQUESTS_UTILITY_ASSISTANCE = 'requests.utilityAssistance',
}
